var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H42",
    stroke: "#FEC10D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H42",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H36",
    stroke: "#FEC10D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H36",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H42",
    stroke: "#FEC10D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H42",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38H36",
    stroke: "#FEC10D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38H36",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDetails);
export default __webpack_public_path__ + "static/media/list-details.0235895ccc2064c5a2b1b2decbf7a136.svg";
export { ForwardRef as ReactComponent };